<script setup>
const props = defineProps({
  type: {
    default: undefined,
  },
  filterKey: {
    default: undefined,
  },
  options: {
    default: undefined,
  },
  isOpen: {
    default: undefined,
  },
  close: {
    default: undefined,
  },
  config: {
    default: undefined,
  },
})

const emit = defineEmits(['apply'])
const { t } = useI18n()

const currentValue = ref()

const dataQueryStore = inject('data-query-store')

const modelValue = computed(() => {
  return dataQueryStore?.value?.state?.value?.filters?.[props.filterKey]
})

const noChange = computed(() => {
  if (Array.isArray(modelValue.value) && Array.isArray(currentValue.value)) {
    return (
      modelValue.value?.length === currentValue.value?.length
      && modelValue.value?.every(v => currentValue.value.includes(v))
    )
  }
  return modelValue.value === currentValue.value
})

watch(
  () => props.isOpen,
  () => {
    currentValue.value = modelValue.value
  },
  { immediate: true },
)

function apply() {
  dataQueryStore?.value?.actions.updateFilter({
    key: props.filterKey,
    value: currentValue.value,
  })
  emit('apply')
  if (props?.close)
    props.close()
}
</script>

<template>
  <div class="data-filter-component flex flex-col">
    <div class="max-h-410px overflow-y-auto">
      <FormKit
        v-if="type === 'radiolist'"
        v-model="currentValue"
        type="radio"
        :options="options"
        :classes="{
          outer: '$remove:mb-4 border-b-1 border-surface-600 py-2 px-4',
        }"
      />
      <FormKit
        v-else-if="type === 'checkboxlist'"
        v-model="currentValue"
        type="checkbox"
        :options="options"
        :group-by="config?.groupBy"
        :classes="{
          outer: '$remove:mb-4 border-b-1 border-surface-600 py-2 px-4',
        }"
      />
      <!-- TODO: support async query for Combobox -->
      <DSComboboxInput
        v-else-if="type === 'combobox'"
        v-model="currentValue"
        :options="options"
        class="mx-4 mt-2"
      />
      <!-- TODO: support async query for PersonCombobox -->
      <DSPersonComboboxInput
        v-else-if="type === 'person'"
        v-model="currentValue"
        :options="options"
        class="mx-4 mt-2"
      />
      <div
        v-else-if="type === 'daterange'"
        class="border-b-1 border-surface-600 pb-4"
      >
        <DSDateRangeInput
          v-model="currentValue"
          class="m-4 mb-0"
        />
      </div>
    </div>

    <div class="data-filter-component-footer mx-4 my-3">
      <button
        class="btn-sm w-full btn-fill-secondary"
        :disabled="noChange"
        @click="apply"
      >
        {{ t('Apply Filter') }}
      </button>
    </div>
  </div>
</template>

<i18n>
{
  "en-us": {
    "Apply Filter": "Apply Filter"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Apply Filter": "Filter anwenden"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Apply Filter": "Appliquer un filtre"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Apply Filter": "Aplicar filtro"
}
</i18n>
